import React, { Fragment } from "react";
import { Button, Row, Col, Alert } from "react-bootstrap";

const CourseForm = ({ info }) => {
  return (
    <Fragment>
      {info.courseNumber} - {info.courseName}
    </Fragment>
  );
};

const WeekForm = ({ weekId, week, handelAssessment }) => {
  return (
    <Fragment>
      {week ?? undefined} 주차
      <Button onClick={handelAssessment} value={weekId} className="me-2">
        수행평가
      </Button>
    </Fragment>
  );
};

export const AssessmentHomeForm = ({ asssessments, handleDetail }) => {
  return (
    <Fragment>
      {asssessments && asssessments.length > 0 ? (
        asssessments.map((it, index) => {
          return (
            <Fragment key={index}>
              <hr />
              <Row>
                <Col>
                  <CourseForm info={it.course} />
                </Col>
                <Col>
                  {it.weeks.map((st, sIndex) => {
                    return (
                      <span key={sIndex}>
                        <WeekForm
                          weekId={st._id}
                          week={st.week}
                          handelAssessment={handleDetail}
                        />
                      </span>
                    );
                  })}
                </Col>
              </Row>
            </Fragment>
          );
        })
      ) : (
        <div>데이타가 없습니다.</div>
      )}
      <hr />
    </Fragment>
  );
};
